import { useState } from 'react';

interface FaqItem {
  question: string;
  answer: string;
}

const faqItems: FaqItem[] = [
  {
    question: 'Co to jest Kakobuy Spreadsheet?',
    answer: 'Kakobuy Spreadsheet to gotowa, uporządkowana lista produktów dostępnych przez platformę Kakobuy. Zawiera setki starannie wyselekcjonowanych produktów pogrupowanych w kategorie takie jak buty, odzież, akcesoria i wiele więcej. To najszybszy sposób na znalezienie sprawdzonych produktów z Chin bez konieczności samodzielnego przeszukiwania tysięcy ofert.',
  },
  {
    question: 'Czy Kakobuy Spreadsheet jest darmowy?',
    answer: 'Tak, Kakobuy Spreadsheet jest całkowicie darmowy. Możesz przeglądać listy produktów, kategorie i korzystać ze wszystkich linków bez żadnych opłat. Płacisz tylko za produkty, które zdecydujesz się kupić przez platformę Kakobuy.',
  },
  {
    question: 'Jak znaleźć produkty w Kakobuy Spreadsheet?',
    answer: 'Wystarczy wybrać interesującą Cię kategorię z naszej listy – na przykład Shoes, Hoodies czy Accessories. Każda kategoria przekieruje Cię bezpośrednio do odpowiedniej listy produktów na stronie Kakobuy Spreadsheet, gdzie znajdziesz gotowe linki do zakupu.',
  },
  {
    question: 'Czy Kakobuy wysyła do Polski?',
    answer: 'Tak, Kakobuy oferuje wysyłkę do Polski. Dostępnych jest kilka metod dostawy o różnym czasie realizacji i koszcie. Paczki są śledzone, a w razie potrzeby możesz wykupić dodatkowe ubezpieczenie przesyłki.',
  },
  {
    question: 'Jak często aktualizowane są listy produktów?',
    answer: 'Listy produktów w Kakobuy Spreadsheet są regularnie aktualizowane, aby zapewnić dostęp do najnowszych i najlepszych ofert. Produkty, które są niedostępne, są usuwane, a nowe, popularne pozycje są dodawane na bieżąco.',
  },
  {
    question: 'Czy mogę ufać sprzedawcom na Kakobuy?',
    answer: 'Kakobuy współpracuje ze sprawdzonymi sprzedawcami. Dodatkowo platforma oferuje zdjęcia QC (kontroli jakości) przed wysyłką, dzięki czemu możesz sprawdzić produkt zanim trafi do Ciebie. W razie problemów, obsługa klienta Kakobuy pomaga w rozwiązaniu sporów.',
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section id="faq" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            Często Zadawane Pytania – Kakobuy Spreadsheet
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto leading-relaxed">
            Odpowiadamy na najczęstsze pytania dotyczące <strong>Kakobuy Spreadsheet</strong> i zakupów przez platformę Kakobuy.
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden transition-all duration-200"
            >
              <button
                onClick={() => toggle(idx)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {item.question}
                </span>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === idx ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500 text-lg"></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === idx ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}